import React from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Checklist } from './components/Checklist';
import { Testimonials } from './components/Testimonials';
import { Checkout } from './components/Checkout';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#EFE4CC] text-slate-800 font-sans selection:bg-teal-200" data-id="element-0">
      <PurchasePopup data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <Solution data-id="element-5" />
        <Tomos data-id="element-6" />
        <Bonos data-id="element-7" />
        <Checklist data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Checkout data-id="element-10" />
        <FAQ data-id="element-11" />
        <Guarantee data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}